import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { StoreDeliverySettingTemplate } from 'components/Templates'

const StoreDeliverySetting: FC = () => {
  return (
    <Layout title={'配送設定'}>
      <StoreDeliverySettingTemplate />
    </Layout>
  )
}

export default StoreDeliverySetting
